import React, { useState } from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import { CustomLableButton } from "../../Utils/CustomButton/CustomButton";

export default function AllStudentTable({ props, width }) {
  const [stateElem] = useState(Object.entries(props));


  return (
    <Container>
      {stateElem.map((data) => (
        <Text myWidth={width}>{data[1]}</Text>
      ))}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  border: 2px solid ${Theme.colorBorderTextField};
  margin: 1rem;
  padding: 0 1rem;
  border-radius: 8px;
`;

const Text = styled.p`
  color: ${Theme.colorFontBlack};
  font-size: ${Theme.fontSiz};
  font-weight: ${Theme.fontWeigh};
  width: ${(props) => props.myWidth};
  margin: 0.7rem 0;
`;
